import { toast } from "react-toastify";
import { handleError } from "../../../utils/parseApiReturn";
import { ApiService } from "../../../config";
import axios from "axios";

const login = async (email: string, password: string): Promise<any> => {
  try {
    const baseUrl = import.meta.env.VITE_APP_URL_BASE;
    const res = await axios.post(`${baseUrl}/auth`, {
      email,
      password,
    });
    const { error, data, message } = res.data;
    if (error) {
      toast.error(message);
      return null;
    } else {
      return data;
    }
  } catch (error: any) {
    const { message } = handleError(error, "Erro desconhecido ao logar.");
    toast.error(message);
    return null;
  }
};

const createUser = async (
  name: string,
  email: string,
  password: string
): Promise<boolean> => {
  try {
    const res = await ApiService.post(`/users/no-auth/create`, {
      name,
      email,
      password,
    });
    const { error, message } = res.data;
    if (error) {
      toast.error(message);
      return false;
    } else {
      toast.success(message);
      return true;
    }
  } catch (error: any) {
    const { message } = handleError(error, "Erro ao criar usuário.");
    toast.error(message);
    return false;
  }
};

const startGoogleOAuth = async (): Promise<void> => {
  try {
    // Obtém a URL base da sua API a partir da configuração do ApiService
    const baseUrl = import.meta.env.VITE_APP_URL_BASE;
    if (!baseUrl) {
      toast.error("A URL da API não está configurada.");
      return;
    }

    // Redireciona o navegador para o endpoint de autenticação do backend.
    // O backend irá então redirecionar para a página de login do Google.
    window.location.href = `${baseUrl}/auth/google`;
  } catch (error: any) {
    const { message } = handleError(error, "Erro ao iniciar OAuth do Google.");
    toast.error(message);
  }
};

const finishGoogleOAuth = async (code: string): Promise<string | null> => {
  try {
    const res = await ApiService.post(`/auth/google/callback`, { code });
    const { error, data, message } = res.data;
    if (error || !data) {
      toast.error(message || "Falha ao concluir OAuth.");
      return null;
    }
    return data as string;
  } catch (error: any) {
    const { message } = handleError(error, "Erro no callback do Google.");
    toast.error(message);
    return null;
  }
};
const getCurrentUser = async (token: string): Promise<any | null> => {
  try {
    const baseUrl = import.meta.env.VITE_APP_URL_BASE;
    const res: any = await axios.get(`${baseUrl}/users/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const { error, data } = res;
    if (error) {
      toast.error("Não foi possível obter o usuário atual.");
      return null;
    }
    console.log("[LoginService] User data from /users/me:", data);
    return data;
  } catch (error: any) {
    const { message } = handleError(error, "Erro ao obter o usuário atual.");
    toast.error(message);
    return null;
  }
};
const forgotPassword = async (email: string): Promise<boolean> => {
  try {
    const baseUrl = import.meta.env.VITE_APP_URL_BASE;
    const res = await axios.post(`${baseUrl}/auth/forgot-password`, { email });
    const { error, message } = res.data;
    if (error) {
      toast.error(message);
      return false;
    }
    toast.success(
      message ||
        "Se o e-mail estiver cadastrado, você receberá as instruções de redefinição.",
    );
    return true;
  } catch (error: any) {
    const { message } = handleError(
      error,
      "Erro ao solicitar redefinição de senha.",
    );
    toast.error(message);
    return false;
  }
};

const resetPassword = async (
  token: string,
  newPassword: string,
  confirmPassword: string,
): Promise<boolean> => {
  try {
    const baseUrl = import.meta.env.VITE_APP_URL_BASE;
    const res = await axios.post(`${baseUrl}/auth/reset-password`, {
      token,
      newPassword,
      confirmPassword,
    });
    const { error, message } = res.data;
    if (error) {
      toast.error(message);
      return false;
    }
    toast.success(message || "Senha redefinida com sucesso");
    return true;
  } catch (error: any) {
    const { message } = handleError(error, "Erro ao redefinir a senha.");
    toast.error(message);
    return false;
  }
};

export const LoginService = {
  login,
  createUser,
  startGoogleOAuth,
  finishGoogleOAuth,
  getCurrentUser,
  forgotPassword,
  resetPassword,
};
